angular.module('vm.common', [
    'ngCookies'
]);